import { useSyncExternalStore } from "react";

import tokenManager from "@/utils/tokenManager";
import { isAuth0Enabled } from "./authConfig";
import { getAuthStatus, subscribeAuthStatus } from "./authState";

/**
 * Reactive "is there an authenticated session right now" for both auth modes.
 *
 * Components that fetch OUTSIDE the <Auth> gate (FetchFiltersAndSegments,
 * ValidateView, useViewLanding) must not read the legacy session token to decide
 * whether to fetch: under Auth0 that token is always absent, so the fetch would
 * never fire. Under Auth0 the equivalent signal is that AuthProvider has settled
 * an authenticated session (authState phase === "authenticated"); under the
 * legacy path it is the presence of the session token. This is reactive so a
 * gated effect re-runs once auth becomes ready.
 */
export const useHasActiveSession = (): boolean => {
  const phase = useSyncExternalStore(
    subscribeAuthStatus,
    () => getAuthStatus().phase,
  );
  if (isAuth0Enabled()) return phase === "authenticated";
  return !!tokenManager.getToken();
};
